<template>
  <template-corporation
    :hasFinalTaxType="hasFinalTaxType"
    :fact="fact"
    :penalty="penalty"
    :pathName="pathName"
    :showBusiness="showBusiness"
  >
    <div slot="info-contents" class="cck-detail">
      <div class="card">
        <div class="card-content">
          <div class="card-img">
            <img :src="ALERTICON" alt="ALERTICON" />
          </div>
          <div class="card-detail">
            <span class="white"
              >จากลักษณะธุรกิจของคุณเราแนะนำ ให้จดทะเบียนภาษีมูลค่าเพิ่ม (VAT)
              เพื่อให้ถูกกฎหมาย </span
            ><span @click="vatOnline" class="underline">ได้ที่นี่</span>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="wrap-link">
          <chevron-right-link
            style="margin: 9px 0"
            @clickLink="goVatDefinition"
            caption="VAT คืออะไร"
          />
          <chevron-right-link
            style="margin: 9px 0"
            @clickLink="goVatBenefit"
            caption="ทำไมต้องจด VAT"
          />
          <chevron-right-link
            @clickLink="goToFags"
            style="margin: 9px 0"
            caption="คำถามที่พบบ่อยเกี่ยวกับ VAT"
          />
          <chevron-right-link
            @clickLink="goToFineDetail"
            style="margin: 9px 0"
            caption="รายละเอียดค่าปรับต่างๆ"
          />
        </div>
      </div>
    </div>
    <div slot="to-do">
      <div class="contents">
        <span>6. </span>
        <span class="wld-link">
          <span class="bold">เพื่อผลประโยชน์สูงสุดในการดำเนินกิจการ</span>
          เราแนะนำให้ซื้อสินค้ากับผู้ประกอบการทจดทะเบียน ภาษีมูลค่าเพิ่ม (VAT)
          แล้ว
        </span>
      </div>
    </div>
  </template-corporation>
</template>

<script>
import ALERTICON from "@/assets/images/eva_alert-white-triangle-outline.png";
export default {
  name: "CorpNotRegister",
  props: ["hasFinalTaxType"],
  data() {
    return {
      ALERTICON,
      showBusiness: false,
      pathName: "corp_not_register",
      fact: [
        "คุณจะมีค่าใช้จ่ายเพิ่มเติมที่ตามมาหลังจด VAT คือ ค่าใช้จ่ายในการทำบัญชีและตรวจสอบบัญชี",
        "การไม่จด VAT ทำให้คุณไม่มีหลักฐานเพื่อช่วยในการขอเครดิตจากธนาคารในกรณีที่คุณต้องการเงินทุนเพื่อขยายกิจการในอนาคต",
        "การไม่จด VAT ทำให้คุณอยู่อย่างหวาดกลัวไม่สามารถ Promote ผ่านช่องทาง Mass Communication ต่างๆ ได้",
      ],
      penalty: [
        "คุณอาจต้องจ่ายเงินเพิ่ม เบี้ยปรับ และค่าปรับอาญาจากการทำผิดกฎหมาย",
      ],
    };
  },
  methods: {
    goVatDefinition() {
      this.$router.push({
        path: "/info/vat_definition",
      });
    },
    goVatBenefit() {
      this.$router.push({
        path: "/info/vat_benefit",
      });
    },
    goToFineDetail() {
      this.$router.push({
        path: "/info/fine_detail",
      });
    },
    goToFags() {
      this.$router.push({
        path: "/info/faqs",
      });
    },
  },
};
</script>

<style scoped>
.white {
  color: #ffffff;
}
.underline {
  font-weight: bold;
  color: #ffffff !important;
}
.card {
  background: #f45a49;
  display: flex;
  width: 100%;
  justify-content: center;
}
.card-content {
  width: 100%;
  max-width: 352px;
  display: flex;
}
.card-img {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 16px;
}
.card-detail {
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 19px;
}
.wrap {
  display: flex;
  justify-content: center;
  background: rgb(230 232 236 / 0.2);
  padding: 27px;
}
.wrap-link {
  max-width: 352px;
  width: 100%;
}
@media only screen and (min-width: 769px) {
  .card-content {
    max-width: 1120px;
    justify-content: center;
  }
  .card {
    margin: 0;
    margin-top: 40px;
  }
}
</style>
